import { axios } from '@/utils/request'

/**
 * 查询医生服务审核1
 *
 * @author liwei
 * @date 2022-04-16 16:27:44
 */
export function baDoctorServiceCheckPage (parameter) {
  return axios({
    url: '/baDoctorServiceCheck/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 医生服务审核1列表
 *
 * @author liwei
 * @date 2022-04-16 16:27:44
 */
export function baDoctorServiceCheckList (parameter) {
  return axios({
    url: '/baDoctorServiceCheck/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加医生服务审核1
 *
 * @author liwei
 * @date 2022-04-16 16:27:44
 */
export function baDoctorServiceCheckAdd (parameter) {
  return axios({
    url: '/baDoctorServiceCheck/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑医生服务审核1
 *
 * @author liwei
 * @date 2022-04-16 16:27:44
 */
export function baDoctorServiceCheckEdit (parameter) {
  return axios({
    url: '/baDoctorServiceCheck/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除医生服务审核1
 *
 * @author liwei
 * @date 2022-04-16 16:27:44
 */
export function baDoctorServiceCheckDelete (parameter) {
  return axios({
    url: '/baDoctorServiceCheck/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出医生服务审核1
 *
 * @author liwei
 * @date 2022-04-16 16:27:44
 */
export function baDoctorServiceCheckExport (parameter) {
  return axios({
    url: '/baDoctorServiceCheck/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
